import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  icon: {
    width: "1rem",
    height: "1rem",
  },
});

const PlusIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 16 16" className={styles.icon} fill="none">
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M9.5 6.5V0H6.5L6.5 6.5H0V9.5H6.5L6.5 16H9.5V9.5H16V6.5H9.5Z"
          fill="#FE9400"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(PlusIcon);
